export const KEYS = {
    ENCRYPTED_PAYLOAD: "dkerakt",
    AES_KEY_HEX: "kwmowe",
    IV_HEX: "vwjpwb",
    MAC: "vkritkpw",
    CONVERSATION_ID: "pofwtu",
};

export const GREETING_MSG_PRE = "Hello, I’m Hong Leong Bank’s A.I chat service. I can answer any questions you have about our products and services. For questions specific to your account, please log in on Hong Leong Connect so I can assist you better.\n\nNote: As I am an A.I. bot, I appreciate your patience as I improve on my ability to serve you.\n\nDisclaimer: HLISB does not provide advice or promote, directly or indirectly, any banking products and services that are non-Shariah compliant.";
export const GREETING_MSG_POST = "Hello, I’m Hong Leong Bank’s A.I chat service. I can answer any questions you have about our products and services.";
export const GREETING_MSG_POST2 = "Note: As I am an A.I. bot, I appreciate your patience as I improve on my ability to serve you.";
export const GREETING_MSG_POST3 = "Disclaimer: HLISB does not provide advice or promote, directly or indirectly, any banking products and services that are non-Shariah compliant.";
export const OUTSIDE_OPERATION_MSG = "Our operating hour is 9am to 7pm from Monday to Saturday. Please come back again at the time. Thank you for your understanding.";
export const IDLE_MSG = "Is there anything else that I can help you with?";
export const TRY_MY_BEST_MSG = "I will try my best to answer your questions.";
export const WAIT_MSG = "Please wait for a moment.";
export const PROMOTION_MSG = "Please hold while we connect you with our agent. Check out our latest promotions on https://www.hlb.com.my/main/promotions";
export const CONNECTED_LIVE_AGENT_MSG = "You are connected to live agent.";
export const LIVE_AGENT_UNAVAILABLE_MSG = "Our Live Agent is not available at the moment. Please try again later. Thank you.";
export const END_MSG = "Have a great day!";
export const INPUT_PLACEHOLDER_MSG_PRELOGIN = "Type your message here. We will protect your information under PDPA 2010 but please do not reveal any personal information e.g. IC number, card or account numbers.";
export const INPUT_PLACEHOLDER_MSG_POSTLOGIN = "Type your message here. We will protect your information under PDPA 2010 but please do not reveal any personal information e.g. IC number, card or account numbers.";
export const SURVEY_AGENT = "https://survey.hlb.com.my/efm/se/682C0D24033B15EE";
export const SURVEY_BOT = "https://survey.hlb.com.my/EFM/se/682C0D2464768BB4";
export const CHARACTER_LIMIT = 200;
export const QUERY_PARAMS = window.location.search.substring(1);
export const INTERNAL_PARAM = "m=int";
export const QUEUE_RETRY_COUNT = 30;

export const USER_DATA = JSON.parse(userDataString.replace(/(\w+):/g, '"$1":').replace(/'/g, '"'));
export const CHAT_SESSION_ID = USER_DATA.chatSessionID;
export const SOURCE_CHAT = USER_DATA.SourceChat;
export const IS_LOGIN = USER_DATA.isLoginInFlag.toString().toLowerCase() === "true";

export const CATEGORIES = {
    CASAFD: "Current / Savings / Fixed Deposit",
    LostCard: "Report Lost Card / Fraudulent Transaction",
    HirePurchase: "Hire Purchase",
    PersonalLoans: "Personal Loans",
    Mortgage: "Mortgage",
    DebitCard: "Debit Card / Deposit Account",
    CreditCard: "Credit Card",
    HLConnect: "Hong Leong Connect",
};

export const CATEGORIES_DIV = {
    "category-casa-fd": "CASAFD",
    "category-report-lost": "LostCard",
    "category-auto-loan": "HirePurchase",
    "category-personal-loan": "PersonalLoans",
    "category-mortgage": "Mortgage",
    "category-debit-card": "DebitCard",
    "category-credit-card": "CreditCard",
    "category-hlb-connect": "HLConnect",
};

export const NOT_FOUND_MENU_MSG = `I'm sorry, as an A.I Chat Service, I am unable to assist you with that question at this time. Please type "Chat Now" to connect to our Senior Specialist.`;

export const ALLOWED_HOSTNAME = [
    // "localhost",
    "10.3.14.121",
    "uat.hlb.com.my",
    "uat.hlisb.com.my",
    "t1uat.hongleongconnect.com.my",
    "www.hlb.com.my",
    "www.hlisb.com.my",
    "s.hongleongconnect.my",
]